import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';


const Libros = () => {
    const [t, i18n] = useTranslation("biblioteca");
    const [t2] = useTranslation("home");
    const [t3] = useTranslation("libroBitcoin");
    const liga_lang1 = "/" + i18n.language + "/LibroSociedades";
    const liga_lang2 = "/" + i18n.language + "/LibroLibertad";
    const liga_lang3 = "/" + i18n.language + "/LibroNegocios";
    const liga_lang4 = "/" + i18n.language + "/LibroBitcoin";
    const liga_lang5 = "/" + i18n.language + "/LibroBitcoin#donde-comprar";

    const bannerImage =
        t3("donde.btnaudio") === "ES"
            ? "/assets/img2026/biblioteca_banner.png"
            : "/assets/img2026/RBS-libro-bit.png";

    const [im] = useTranslation("libroBitcoin");
    const bannerImageBlanco =
        im("donde.btnaudio") === "ES"
            ? "/assets/img2026/book_cover_4.png"
            : "/assets/img2026/book_cover_4_en.png";
    const bannerImageBitcoin =
        im("donde.btnaudio") === "ES"
            ? "/assets/img2026/book_cover_1.png"
            : "/assets/img2026/bitcoin_englightment.png";


    const trackAnalyticsClick = (label) => {
        window.gtag('event', 'click', {
            event_category: 'Biblioteca',
            event_label: label,
            value: 1
        });
    };

    return (
        <div>
            <div class="_ngcontent-ng-c168712225 _nghost-ng-c2439668831">
                <article role="button" tabindex="0" class="biblioteca-banner">
                    <div class="biblioteca-banner__media"><img
                        class="biblioteca-banner__image biblioteca-banner__image--mobile"
                        src={bannerImage} alt="Banner del libro La iluminación de bitcoin" /><img
                            class="biblioteca-banner__image biblioteca-banner__image--desktop"
                            src={bannerImage} alt="Banner del libro La iluminación de bitcoin" /></div>
                    <div class="biblioteca-banner__copy">

                        <h2 class="biblioteca-banner__title">{t2("2026.libro1")}</h2>
                        <p class="biblioteca-book-card__author biblioteca-book-card__author_princ">Ricardo Salinas</p>
                        <p class="biblioteca-banner__summary">{t("2026.desc1")}</p>
                        <div class="biblioteca-banner__links"><a
                            href={liga_lang4}> {t2("2026.bookmore")} </a>
                            <a target='_blank'
                                href={
                                    i18n.language === "en"
                                        ? "https://www.amazon.com/Bitcoin-Enlightenment-Ending-Fiat-Dark/dp/1967693080/ref=tmm_hrd_swatch_0?_encoding=UTF8&dib_tag=se&dib=eyJ2IjoiMSJ9.FytTmcL70Yo8P5eS8MgLXyrvDDuYazZxuzzn6ZPZOWim4xe_Vc3MGePvx5XdzrHSAqSzzOdl4cuw6rIhcUAgvukDZlt6KEcb8fRwYdp5qS122gAgnrliYbiiAm3W2opBSbKJJo8mevnGzBD5S_VST9HberRgA4AI15At48a5TIblOcEB4XSFGEmaRADvT9p8-NqOG8K9o02IhnvG0pX4QzTHMiI5EU9uWmid_wc1-mE.OhF7v8a9v1t9BoU6qQ1Mp-gyy-pm8HcM4f7cJZk0oJQ&qid=1778787227&sr=8-1"
                                        : "https://www.amazon.com.mx/ILUMINACI%C3%93N-BITCOIN-OSCURA-DINERO-Spanish/dp/1967693048/ref=tmm_hrd_swatch_0?_encoding=UTF8&dib_tag=se&dib=eyJ2IjoiMSJ9.oEvBvIrUdeO5BpgY00JMZWYZUDgBVLBWSCvXo6r1F12H59tlebYOm45rSlT5y8-tVBUmR9J3c81EamxTNeoRch7HDsclwLiUIPJFy5Z0uwqCglO7T243bgC2kdUIHjBMFjk3VIGr9BiZW1JComMPYA8VDL2mDhhtZ6jnGrah8Oeofk5TituNYbrhub6Ll_JvhdumotMnY53_hlit03ZIl7_UD4KrduXCCQio8f9OC8LcZNTxhk4_6lEit5sRh2-6neV7kCJ_zNyo964ZOeX6gQ.DBaUMyz5dHMLmqMyhPslEPLBc9aymsNM25bXqAPFqK4&qid=1753227141&sr=8-1"
                                }> {t("2026.comprar")}
                            </a>
                        </div>
                    </div>
                </article>
            </div>
            <div class="_ngcontent-ng-c168712225 _nghost-ng-c54415964">

                <section aria-label="Lista de libros" class="biblioteca-books">
                    <div class="_ngcontent-ng-c54415964 _nghost-ng-c2418364703">
                        <a className='liga_card_book_rbs' href={liga_lang3}>
                            <article role="button" tabindex="0" class="biblioteca-book-card biblioteca-book-card-poiner">
                                <div class="biblioteca-book-card__inner">
                                    <div class="biblioteca-book-card__media"><img
                                        loading="lazy" src="/assets/img2026/book_cover_1.png"
                                        alt="Ideas que transforman negocios para cambiar al mundo" /></div>
                                    <div class="biblioteca-book-card__copy">

                                        <h3 class="biblioteca-book-card__title">{t2("2026.libro2")}</h3>
                                        <p class="biblioteca-book-card__author ">Ricardo Salinas</p>
                                        <p class="biblioteca-book-card__summary">{t("2026.desc2")}
                                        </p><a class="biblioteca-book-card__link"
                                            href={liga_lang3}> {t2("2026.bookmore")} </a>
                                    </div>
                                </div>
                            </article>
                        </a>
                    </div>
                    <div class="_ngcontent-ng-c54415964 _nghost-ng-c2418364703">
                        <a className='liga_card_book_rbs' href={liga_lang1}>
                            <article role="button" tabindex="0" class="biblioteca-book-card biblioteca-book-card-poiner">
                                <div class="biblioteca-book-card__inner">
                                    <div class="biblioteca-book-card__media"><img
                                        loading="lazy" src="/assets/img2026/book_cover_2.png"
                                        alt="Ideas que transforman sociedades para cambiar al mundo" /></div>
                                    <div class="biblioteca-book-card__copy">

                                        <h3 class="biblioteca-book-card__title">{t2("2026.libro3")}</h3>
                                        <p class="biblioteca-book-card__author">Ricardo Salinas</p>
                                        <p class="biblioteca-book-card__summary">{t("2026.desc3")}
                                        </p><a class="biblioteca-book-card__link"
                                            href={liga_lang1}> {t2("2026.bookmore")} </a>
                                    </div>
                                </div>
                            </article>
                        </a>
                    </div>
                    <div class="_ngcontent-ng-c54415964 _nghost-ng-c2418364703">
                        <a className='liga_card_book_rbs' href={liga_lang2}>
                            <article role="button" tabindex="0" class="biblioteca-book-card biblioteca-book-card-poiner">
                                <div class="biblioteca-book-card__inner">
                                    <div class="biblioteca-book-card__media"><img
                                        loading="lazy" src={bannerImageBlanco}
                                        alt="Ideas sobre la libertad para cambiar al mundo" /></div>
                                    <div class="biblioteca-book-card__copy">

                                        <h3 class="biblioteca-book-card__title">{t2("2026.libro4")}</h3>
                                        <p class="biblioteca-book-card__author">Ricardo Salinas</p>
                                        <p class="biblioteca-book-card__summary">{t("2026.desc4")}
                                        </p><a class="biblioteca-book-card__link"
                                            href={liga_lang2}> {t2("2026.bookmore")} </a>
                                    </div>
                                </div>
                            </article>
                        </a>
                    </div>
                    <div class="_ngcontent-ng-c54415964 _nghost-ng-c2418364703">
                        <article role="button" tabindex="0" class="biblioteca-book-card">

                        </article>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default Libros;